import { typography } from '@mehilainen/mds-tokens';
export const getThemeBadge = (_tokens) => ({
    MuiBadge: {
        styleOverrides: {
            badge: {
                fontSize: typography.baseTypography.size[200].rem,
                fontWeight: typography.baseTypography.weight.Medium,
                lineHeight: typography.baseTypography.height.Small,
                height: 'unset',
                padding: '4px 6px',
            },
        },
    },
});
